import type { ComponentProps } from "react";
import { memo } from "react";
import type { TerminalResult } from "@/lib/types";
import { cn } from "@/lib/utils";

const TerminalOutput = memo(
  ({
    className,
    outputs,
  }: ComponentProps<"div"> & {
    outputs: TerminalResult[];
  }) => {
    return (
      <div
        data-testid="terminal-output"
        className={cn(
          "flex flex-1 flex-col-reverse overflow-y-auto overflow-x-hidden break-all text-left py-6 px-6",
          className,
        )}
      >
        {outputs.map(({ id, command, result }) => (
          <div key={id}>
            <div>{`> ${command}`}</div>
            {result.output.map((line) => (
              <div
                key={`${id}_${line}`}
                className={result.error ? "text-red-500" : ""}
              >
                {line || "\u00A0"}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  },
);

export { TerminalOutput };
